import React from "react";
import "../styles/contact.css";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import { useFadeIn } from "./hooks/useFadeIn";

const Contact: React.FC = () => {
    const { ref, isVisible } = useFadeIn();

    return (
        <section
            id="contact"
            ref={ref}
            className={`contact-section ${isVisible ? "fade-in" : ""}`}
        ><h2 className="section-title">Contact Us</h2>
            <hr className="fancy-hr" />
            <div className="contact-container">
                {/* Left: Google Map */}
                <div className="contact-map">
                    <a
                        href="https://www.google.com/maps/place/Your+Spa+Address"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <iframe
                            title="Google Map"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2879.4505355258398!2d-79.29056299999999!3d43.80501339999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d4d3ece6efdd47%3A0xfb29703673ee9857!2sCedarwood%20Spa%20%26%20Wellness!5e0!3m2!1sen!2sca!4v1757852658367!5m2!1sen!2sca"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen
                            loading="lazy"
                        ></iframe>
                    </a>
                </div>
                {/* Right: Contact Info */}
                <div className="contact-info">
                    <p>📍 3272 Midland Ave B108, Scarborough, ON M1V 0C4</p>
                    <p>
                        📞 <a href="tel:+14162922880">+1 (416) 292-2880</a>
                    </p>
                    <p>
                        ✉️ <a href="mailto:cedarwoodspanwellness@gmail.com">cedarwoodspanwellness@gmail.com</a>
                    </p>

                    <div className="social-icons">
                        <a href="https://www.facebook.com/share/19jkGxqGyB/?mibextid=wwXIfr" target="_blank" rel="noreferrer">
                            <FaFacebookF />
                        </a>
                        <a href="https://www.instagram.com/cedarwoodspawellness?igsh=N3MxODUxNTIwZXM1" target="_blank" rel="noreferrer">
                            <FaInstagram />
                        </a>
                        {/* <a href="https://twitter.com" target="_blank" rel="noreferrer">
                            <FaTwitter />
                        </a> */}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
